import React from 'react';
import { useSelector } from 'react-redux';

import {
  Header,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Logo, Hamburger } from '../../components';
import MainMenu from '../Menu/Main/index';

import './style.scss';

const Navigation = ({ path, entityId, entityTypeTarget }) => {

  const enityFieldLogo = useSelector((state) => state.getIn(['node', entityId, 'field_logo', '0'], null));
  const refFieldLogo = useSelector((state) => state.getIn(['node', entityId, 'field_municipality', '0', 'entity', 'field_logo', '0'], null));
  let source;
  let alt;

  if (entityTypeTarget === 'municipality') {
    source = enityFieldLogo.get('url');
    alt = enityFieldLogo.get('alt');
  } else if (refFieldLogo) {
    source = refFieldLogo.get('url');
    alt = refFieldLogo.get('alt');
  }

  return (
    <div className="Navigation">
      <Header
        withAnimation
        logo={<Logo path={source} alt={alt} />}
        menu={<MainMenu path={path} />}
        customHamburger={<Hamburger />}
      />
    </div>
  );
};

export default Navigation;
